import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { Typography, Box } from '@material-ui/core';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';
import { doubleActionPrevent } from '../../../utils/helpers';
import Table from '../../../containers/common/tables/tableContainer';
import { referralSourcesEndPoint } from '../../../settings/constants';
import { common, toggleGrey } from '../../../theme/AllocateBaseTheme';
import globals from '../../../globals/communityGlobals';
import DefaultPageWrapper from '../../../containers/PageStructure/DefaultPageWrapper/DefaultPageWrapperContainer';

const locale = globals.getAreas(['referralSources', 'error', 'pageTitles']);
const maxNameLength = 50;

class ReferralSourcesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reloadData: false,
      referraSourceName: '',
      errorMessage: '',
    };
  }

  handleAddClick = doubleActionPrevent.bind(this)(
    'Add',
    async () => {
      await this.props.createReferralSource({ name: this.state.referralSourceName });
    },
    () => {
      this.setState({
        referralSourceName: '',
        reloadData: !this.state.reloadData,
      });
    },
  );

  handleUpdateStatus = referralSourceId => (event, isInputChecked) => {
    this.props.updateReferralSource({
      referralSourceId,
      isActive: isInputChecked,
    });
  };

  updateReferralSourceNameValue = (event, value) => {
    const stateUpdate = { errorMessage: '' };
    if (value.length > maxNameLength) {
      stateUpdate.errorMessage = locale.getMsg('validationMaxLength', [maxNameLength.toString()]);
    } else {
      stateUpdate.referralSourceName = value;
    }
    this.setState(stateUpdate);
  };

  render() {
    const columns = [
      {
        Header: locale.getMsg('tableNameHeader'),
        accessor: 'name',
      },
      {
        Header: '',
        id: 'isActive',
        accessor: row => (
          <div className="col-c4 formsytext-css">
            <span>
              <Toggle
                id={row.id}
                defaultToggled={row.isActive}
                onToggle={this.handleUpdateStatus(row.id)}
                thumbStyle={toggleGrey.thumbStyle}
                trackStyle={toggleGrey.trackStyle}
              />
            </span>
          </div>
        ),
      },
    ];

    const { errorMessage, referralSourceName } = this.state;
    return (
      <DefaultPageWrapper pageTitle={locale.getMsg('referralSources')}>
        <Box className="filter-section" display="flex" flexDirection="column" alignItems="flex-start" px={2} py={1}>
          <Box>
            <Typography variant="h6">{locale.getMsg('referralSourcesInputLabelText')}</Typography>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="flex-start">
            <Box p={1}>
              <div style={{ position: 'relative', width: '250px' }}>
                <TextField
                  style={{ position: 'absolute', top: '-29px' }}
                  multiLine
                  rows={1}
                  rowsMax={3}
                  errorText={errorMessage}
                  errorStyle={common.errorStyle}
                  // floatingLabelStyle={textFieldStyle.floatingLabelStyle}
                  // floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
                  // style={multiLineText.style}
                  // inputStyle={multiLineText.inputStyle}
                  // underlineStyle={multiLineText.underlineStyle}
                  // underlineFocusStyle={multiLineText.underlineFocusStyle}
                  floatingLabelText={locale.getMsg('referralSourcesInputFieldText')}
                  value={referralSourceName}
                  onChange={this.updateReferralSourceNameValue}
                />
              </div>
            </Box>
            <Box p={1}>
              <RaisedButton
                primary
                // style={textFieldStyle.style}
                disabled={!referralSourceName}
                onClick={this.handleAddClick}
                label={locale.getMsg('addButton')}
              />
            </Box>
          </Box>
        </Box>
        <Box display="flex" px={2}>
          <Box flexGrow={1}>
            <Table
              triggerReload={this.state.reloadData}
              columns={columns}
              endpoint={referralSourcesEndPoint}
              responseObjectName="options"
              reduxIdentifier="referralSources"
              initialSearchParams={{
                pageNumber: 1,
                pageSize: 5,
                sortColumn: 'Name',
                sortDirection: 'asc',
              }}
            />
          </Box>
        </Box>
      </DefaultPageWrapper>
    );
  }
}

ReferralSourcesForm.propTypes = {
  createReferralSource: PropTypes.func.isRequired,
  updateReferralSource: PropTypes.func.isRequired,
};

export default ReferralSourcesForm;
